export default __webpack_public_path__ + "static/media/kyselyt-taytetyt-darkblue.345e5223.svg";